import Cookies from 'js-cookie';
import {
  getCurrencyString,
  initializeCart,
  parseMoneyToFloat
} from '../updateCart';

export default class Cart {
  constructor() {
    this.cart = document.querySelector('.cart-drawer-container.full-page');
    this.currency = this.cart.dataset.currency;
    this.itemContainer = this.cart.querySelector('.cart-container .items');
    this.freeSampleEl = this.cart.querySelector('.free-sample');
    this.freeSampleAddButtons = this.freeSampleEl.querySelectorAll('.item button');
    this.orderSummaryEl = this.cart.querySelector('footer');
    this.cartCountEl = this.cart.querySelector('.header h1 span');
    this.subtotalEl = this.cart.querySelector('.subtotal p');

    this.minusButtons = this.cart.querySelectorAll('button.minus');
    this.plusButtons = this.cart.querySelectorAll('button.plus');

    this.minusButtons.forEach((button) => {
      button.addEventListener('click', this.updateLineItemQuantity.bind(this, '-'));
    });

    this.plusButtons.forEach((button) => {
      button.addEventListener('click', this.updateLineItemQuantity.bind(this, '+'));
    });

    this.freeSampleAddButtons.forEach((button) => {
      button.addEventListener('click', this.addFreeSample.bind(this));
    });

    this.removeFreeProduct();
    this.removeProduct();

    this.removeKitProductFromCart();
    this.updateKitProductQty();
  }

  removeFreeProduct(){
    document.querySelectorAll('.js-remove-gift').forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        const updates = {};
        const giftId = this.getAttribute('data-gift-id');
        const productId = this.getAttribute('data-product-id');

        if(giftId){
          updates[giftId] = 0;
        }

        if(productId) {
          updates[productId] = 0
        }

        fetch(`/cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: updates
          })
        }).then(_ => {
          window.location.reload();
        })
      })
    })
  }

  removeProduct(){
    document.querySelectorAll('.js-remove-item').forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        const updates = {};
        const productId = this.getAttribute('data-product-id');
        const lineId = Number(this.getAttribute('data-line-id'));

        updates['line'] = lineId;
        updates['quantity'] = 0;

        console.log(updates);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updates)
        }).then(_ => {
          initializeCart();
        })
      })
    })
  }
  removeKitProductFromCart(){
    const lineItems = document.querySelectorAll('.line-item');

    lineItems.forEach(lineItem => {
      const lineItemRemove = lineItem.querySelector('span.js-remove-kit');
      const lineItemKitId = lineItem.dataset.bundlekit;

      if (lineItemRemove != null) {
        lineItemRemove.addEventListener('click', (event) => {
          const minicartItems = document.querySelectorAll('.minicart-item');

          minicartItems.forEach(minicartItem => {
            const minicartItemRemove  = minicartItem.querySelector('.push.kit-parent button');
            const minicartItemId      = minicartItem.dataset.kitid;

            if (minicartItemRemove != null) {
              if (minicartItemId === lineItemKitId) {
                minicartItemRemove.click();
              };
            };
          });
        });
      };
    });
  }

  updateKitProductQty(){
    const lineItems = document.querySelectorAll('.line-item');

    lineItems.forEach(lineItem => {
      const lineItemUpdates         = lineItem.querySelectorAll('.js-update-qty');

      const lineItemMinus           = lineItem.querySelector('.js-minus');
      const lineItemPlus            = lineItem.querySelector('.js-plus');
      const lineItemKitId           = lineItem.dataset.bundlekit;
      const lineItemID              = lineItem.dataset.id;

      if (lineItemUpdates != null) {
        lineItemUpdates.forEach(lineItemUpdate => {
          lineItemUpdate.addEventListener('click', (event) => {
            const minicartItems = document.querySelectorAll('.minicart-item');

            minicartItems.forEach(minicartItem => {
              let minicartItemTrigger = minicartItem.querySelector('.minus');
              const minicartItemId    = minicartItem.dataset.kitid;
              const itemId            = minicartItem.dataset.id;

              if (lineItemUpdate.classList.contains('js-plus')) {
                minicartItemTrigger = minicartItem.querySelector('.plus');
              }

              if (minicartItemTrigger != null) {
                if (minicartItemId === lineItemKitId && lineItemID === itemId) {
                  minicartItemTrigger.click();
                };
              };
            });
          });
        });
      };
    });
  }

  updateLineItemQuantity(operant, e) {
    console.log('updateLineItemQuantity');

    let el = e.target;
    while (!el.classList.contains('line-item')) el = el.parentElement;

    const variantId = el.dataset.id;
    const countEl = el.querySelector('.adjust-quantity p');
    const unitPriceEl = el.querySelector('.unit-price');

    let count, newValue, newValueStr;
    const currentValue = parseMoneyToFloat(this.subtotalEl.dataset.subtotal);
    const unitPrice = parseMoneyToFloat(unitPriceEl.dataset.price);
    if (operant === '-') {
      count = parseInt(countEl.innerText) - 1;
      newValue = (currentValue - unitPrice).toFixed(2);
      this.cartCountEl.innerText = `${parseInt(this.cartCountEl.innerText) - 1}`;
    } else if (operant === '+') {
      count = parseInt(countEl.innerText) + 1;
      newValue = (currentValue + unitPrice).toFixed(2);
      this.cartCountEl.innerText = `${parseInt(this.cartCountEl.innerText) + 1}`;
    }
    newValueStr = newValue.toString().match(/\d/g).join('');

    countEl.innerText = `${count < 10 ? '0' : ''}${count}`;
    if (operant === '-' && count < 1) {
      el.remove();
    }

    this.subtotalEl.innerText = getCurrencyString(newValueStr, this.currency);
    this.subtotalEl.dataset.subtotal = newValueStr;

    if (parseInt(this.cartCountEl.innerHTML) < 1) {
      this.itemContainer.innerHTML = '<p class="empty">Your shopping cart is empty</p>';
      this.freeSampleEl.classList.add('hidden');
      this.orderSummaryEl.classList.add('hidden');
      this.cart.querySelector('.header h6').style.display = 'none';
    }

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [variantId]: count
          }
        })
      })
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error(`Request rejected with status ${res.status}`);
      })
      .then((res) => {
        initializeCart();

        // TRW 10/24/2020
        // CustomWidgets.removeSampleFromCart(false,Object(_updateCart__WEBPACK_IMPORTED_MODULE_0__["initializeCart"]),res) ;
      });
  }

  addFreeSample(e) {
    let target = e.target;

    const freeSampleContainer = document.querySelector('.cart-drawer-container .free-sample');

    // Disable add free sample button if one already added
    freeSampleContainer.classList.add('hidden');

    while (!target.classList.contains('item')) target = target.parentElement;

    const variantId = target.dataset.id;

    fetch('/cart.js', {
        method: 'GET'
      })
      .then((res) => res.json())
      .then(res => {
        // Check if free sample is already added
        let freeSampleExists = false;
        res.items.forEach(item => {
          if (item.properties) {
            if (item.properties.free_sample === true) freeSampleExists = true;
          }
        })

        return freeSampleExists;
      })
      .then(freeSampleExists => {
        // Only add free sample only if there is none
        if (!freeSampleExists) {
          fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                quantity: 1,
                id: variantId,
                properties: {
                  free_sample: true
                }
              })
            })
            .then((res) => {
              if (res.ok) return res.json();
              else throw Error(`Request rejected with status ${res.status}`);
            })
            .then(() => {
              location.reload();
            })
            .catch(console.log);
        }
      })
      .catch(console.log);
  }
}
